<template>
  <div>
    <logged-in-header />
    <products />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import products from "../components/product/Products";

export default {
  components: {
    loggedInHeader,
    products
  }
};
</script>
